@if (shouldShowNavigator()) {
	<div class="task-details-navigator">
		<button
			type="button"
			class="btn secondary-btn task-details-navigator-btn prev-btn"
			[disabled]="!canGoBack()"
			disabledInteractive
			(click)="onNavigateBack()"
			[attr.aria-label]="previousButtonLabelKey | translate">
			<mat-icon class="ficon-app-chevron-left" aria-hidden="true"></mat-icon>
		</button>
		<button
			type="button"
			class="link-btn task-details-navigator-text"
			(click)="openNavigator.emit()"
			[attr.aria-label]="
				('task-details_nav-open' | translate) + ', ' +
				('task-details_navigator-label' | translate:{current: currentTaskIndex, total: totalTasks})
			">
			{{ 'task-details_navigator-label' | translate:{current: currentTaskIndex, total: totalTasks} }}
		</button>
		<button
			type="button"
			class="btn secondary-btn task-details-navigator-btn next-btn"
			[disabled]="!canGoForward()"
			disabledInteractive
			(click)="onNavigateForward()"
			[class.completed]="isComplete && canGoForward()"
			[attr.aria-label]="'task-details_nav-forward' | translate">
			<mat-icon class="ficon-app-chevron-right" aria-hidden="true"></mat-icon>
		</button>
	</div>
}
